import invariant from 'invariant';
import useMicroBlink from "./micro-blink";
var useOCR = function useOCR() {
  var createRecognize = useMicroBlink();
  return function (config) {
    var microBlink = config.microBlink;
    var _ref = microBlink || {},
      licenseKey = _ref.licenseKey;
    var hooks = {};
    invariant(Boolean(microBlink) === Boolean(licenseKey), 'Must Config licenseKey of Micro Blink');
    if (microBlink && licenseKey) {
      hooks['microBlink'] = createRecognize(licenseKey);
    }
    return hooks;
  };
};
export default useOCR;